import { render, staticRenderFns } from "./NavBarApps.vue?vue&type=template&id=2baf8f58&scoped=true"
import script from "./NavBarApps.vue?vue&type=script&lang=js"
export * from "./NavBarApps.vue?vue&type=script&lang=js"
import style0 from "./NavBarApps.vue?vue&type=style&index=0&id=2baf8f58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baf8f58",
  null
  
)

export default component.exports